<template>
  <header id="cv-header" class="cv-header">

    <div class="container">
      <div class="row">

        <div class="cv-header__logo">
          <div class="site-logo">
            <a href="https://www.murdoch.edu.au/" target="_blank">
              <img :src="logo" alt="Murdoch University logo" />
            </a>
          </div>
        </div>

        <nav class="cv-header__nav-basic">
          <ul class="cv-header__nav-basic-links">
            <li><a href="https://goto.murdoch.edu.au/TeachingPeriodsCensusDates" target="_blank"><span class="far fa-external-link-alt"></span>Teaching
                Periods</a></li>
            <li><a href="https://goto.murdoch.edu.au/Handbook" target="_blank"><span class="far fa-external-link-alt"></span>Handbook</a></li>
            <li><a href="https://goto.murdoch.edu.au/Library" target="_blank"><span class="far fa-external-link-alt"></span>Library</a></li>
            <li><a href="https://goto.murdoch.edu.au/ContactUs" target="_blank"><span class="far fa-external-link-alt"></span>Contact us</a></li>
          </ul>
        </nav>

      </div>
    </div>

  </header>
</template>

<script>
import murdochLogoRed from '../../images/murdoch-logo-red.svg'
export default {
  data() {
    return {
      logo: murdochLogoRed
    }
  }
}
</script>
